module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pr-836bcb814711de3da2063e866565340a.svg";